var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading || _vm.isTranslating
    ? _c("loading")
    : _c(
        "div",
        { staticClass: "trip-details" },
        [
          _vm.settings.modules.ai
            ? _c(
                "div",
                { staticClass: "trip-details-locale" },
                [
                  _vm.item.hasItemsNeedingTranslation
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            class: { "is-loading": _vm.isTranslating },
                            attrs: { disabled: _vm.isTranslating },
                            on: { click: _vm.translateItems },
                          },
                          [_vm._v("Übersetzen")]
                        ),
                      ]
                    : [
                        _vm._l(_vm.translations, function (translation) {
                          return [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.switchLocale(translation)
                                  },
                                },
                              },
                              [
                                _c("gb-flag", {
                                  class: {
                                    "is-selected": translation === _vm.locale,
                                  },
                                  attrs: {
                                    code: _vm.getFlag(translation),
                                    size: "small",
                                    iconPath: "/build/img/flags/",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        }),
                        _vm._v(" "),
                        _vm.locale !== "de_DE"
                          ? _c(
                              "simple-menu",
                              {
                                attrs: {
                                  material: "",
                                  icon: "more_vert",
                                  title: "Menu",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  { on: { click: _vm.forceTranslate } },
                                  [_vm._v("Alles neu übersetzen")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("table-list", {
            attrs: { type: "provider_info", locale: _vm.locale },
            on: {
              delete: (item) => _vm.deleteItem("providerTripDetails", item),
            },
          }),
          _vm._v(" "),
          _c("box-list", {
            attrs: { type: "box_map", locale: _vm.locale },
            on: {
              delete: (item) => _vm.deleteItem("providerTripDetails", item),
            },
          }),
          _vm._v(" "),
          _c("box-list", {
            attrs: { type: "box", locale: _vm.locale },
            on: {
              delete: (item) => _vm.deleteItem("providerTripDetails", item),
            },
          }),
          _vm._v(" "),
          _c("documents", {
            attrs: {
              params: _vm.params,
              uploadData: _vm.uploadData,
              hasFilter: false,
              title: "Dokumente für die Reiseunterlagen",
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }